import angular from 'angular';
import clientListSummaryOfCover from './clientListSummaryOfCover';

export default angular
  .module(
    'insuranceSummaryOfCover.scenes.insuranceSummaryOfCoverModal.scenes.components',
    [],
  )
  .component('clientListSummaryOfCover', clientListSummaryOfCover).name;
